import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { Alert } from '@mui/material';

const DeleteAccountModal = ({ account, shown, onHide, onConfirm }) => {
    return (
        <Dialog
            open={shown}
            onClose={onHide}
            maxWidth="sm"
            fullWidth={true}
        >
            <DialogTitle>Delete account</DialogTitle>
            <DialogContent dividers>
                <Alert severity="error" style={{ marginBottom: '16px' }}>
                    You are about to permanently delete account <strong>{account.id}</strong>.
                </Alert>
                <DialogContentText>
                    Are you sure you want to proceed?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onHide} variant="outlined">Back to safety</Button>
                <Button onClick={onConfirm} color="error">Delete account</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteAccountModal;